import genericModule from "./genericModule";
import camelCase from "lodash/camelCase";

const requireModule = require.context(".", false, /\.js$/);
const modules = {};

requireModule.keys().forEach((fileName) => {
  if (fileName === "./index.js" || fileName === "./genericModule.js") return;

  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ""));
  const moduleContent = requireModule(fileName).default;

  let genericContent = {};
  if (moduleContent.generic) {
    const { attrs, options } = moduleContent.generic;
    genericContent = genericModule(moduleName, attrs, options);
  }

  const namespaced =
    typeof moduleContent.namespaced === "undefined"
      ? true
      : moduleContent.namespaced;

  modules[moduleName] = {
    namespaced,
    state: {
      ...genericContent.state,
      ...moduleContent.state,
    },
    getters: {
      ...genericContent.getters,
      ...moduleContent.getters,
    },
    mutations: {
      ...genericContent.mutations,
      ...moduleContent.mutations,
    },
    actions: {
      ...genericContent.actions,
      ...moduleContent.actions,
    },
  };
});

export default modules;
